import { Link } from "react-router-dom";
import { ArrowUpRight } from "@untitledui/icons/ArrowUpRight";

const ProductCard = ({ icon, label, title, description, href, cardColor = "purple", item }) => {
  return (
    <Link to={href} state={{ dataItem: item }} className={`product-card ${cardColor || ""}`}>
      <img src={icon} className="product-icon" alt={label} />
      <span className="label mb-16">{label}</span>
      <p className="mb-12 text-color-grey">
        <strong className="text-color-grey-900">{title}</strong>
      </p>
      <p className="medium-text mb-16">{description}</p>
      <ArrowUpRight size={28} />
    </Link>
  );
};

export default ProductCard;
